import Vue from "vue";

export default function setDocumentTitle() {
    if (Vue.prototype.isThu) {
        $.resetTitle(Vue.config.lang == 'zh_CN' ? '荷塘雨课堂' : 'Hetang Rainclassroom')
    } else if (Vue.prototype.isChangjiang) {
        $.resetTitle(Vue.config.lang == 'zh_CN' ? '长江雨课堂' : 'Changjiang Rainclassroom')
    } else if (Vue.prototype.isHuanghe) {
        $.resetTitle(Vue.config.lang == 'zh_CN' ? '黄河雨课堂' : 'Huanghe Rainclassroom')
    } else if (Vue.prototype.isGC) {
        $.resetTitle(Vue.config.lang == 'zh_CN' ? '广财慕课' : 'GDUFE MOOC')
    } else if (Vue.prototype.isPro) {
        $.resetTitle(Vue.config.lang == 'zh_CN' ? '云的测试' : 'QijianTest')
    } else if (Vue.prototype.isWind) {
        $.resetTitle(Vue.config.lang == 'zh_CN' ? '风测试' : 'FengTest')
    } else if (Vue.prototype.isYD) {
        $.resetTitle(Vue.config.lang == 'zh_CN' ? '雨豆' : 'Yudou')
    } else {
        $.resetTitle(Vue.config.lang == 'zh_CN' ? '雨课堂' : 'Rain Classroom')
    }
}



// WEBPACK FOOTER //
// ./src/util/setDocumentTitle.js